import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "apexracing.groupsPanelCollapsed"

export default class extends Controller {
  static targets = [
    "heading",
    "chevron",
    "expandedItem",
    "collapsedItem",
    "newGroupInput",
  ]

  connect() {
    let stored = null
    try {
      stored = window.localStorage.getItem(STORAGE_KEY)
    } catch (_) {
      /* ignore */
    }
    this.applyCollapsed(stored === "true")
  }

  toggle() {
    const next = this.element.dataset.collapsed !== "true"
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next))
    } catch (_) {
      /* ignore */
    }
    this.applyCollapsed(next)
  }

  applyCollapsed(collapsed) {
    this.element.dataset.collapsed = String(collapsed)
    if (this.hasHeadingTarget)
      this.headingTarget.dataset.collapsed = String(collapsed)
    if (this.hasChevronTarget)
      this.chevronTarget.dataset.collapsed = String(collapsed)
    this.expandedItemTargets.forEach((el) => {
      el.hidden = collapsed
    })
    this.collapsedItemTargets.forEach((el) => {
      el.hidden = !collapsed
    })
    if (this.hasNewGroupInputTarget) this.newGroupInputTarget.hidden = collapsed
  }
}
